import { AngularMaterialModule } from '../../angular-material.module';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: true,
    imports: [RouterLink, CommonModule, AngularMaterialModule]
})
export class HeaderComponent {



  menuItems = [
    { label: 'Home', link: '/', icon: 'home', isMobile: true },
    { label: 'About Us', link: '/aboutUs', icon: 'person_2', isMobile: true },
    { label: 'Blogs', link: '/blog', icon: 'article', isMobile: true },
    {
      label: 'Financial Planning',
      icon: 'build',
      isDropdown: true,
      dropdownItems: [
        { label: 'Financial Planning', link: '/financial-planning' },
        { label: 'Retirement Planning', link: '/retirement-planning' },
        { label: 'Early Retirement Planning', link: '/early-retirement-planning' },
        { label: 'Children Education Planning', link: '/children-education-planning' },
        { label: 'Children Marriage Planning', link: '/children-marriage-planning' }
      ]
    },
    {
      label: 'Insurance',
      icon: 'shield',
      isDropdown: true,
      dropdownItems: [
        { label: 'Health Insurance', link: '/health-insurance' },
        { label: 'Term Plan', link: '/term-plan' }
      ]
    },
    { label: 'Contact Us', link: '/contactUs', icon: 'contacts', isMobile: true }
  ];

  item: any;

  scrollToTarget() {
    document.querySelector('#contactTarget')!.scrollIntoView({behavior: 'smooth'});
  }

}
